import useStyles from './styles';
import Icon from '../../Icon/Icon';

function Radio({ selected }: RadioProps) {
  const classes = useStyles();

  return (
    <Icon
      name={selected ? 'filledCircle' : 'circle'}
      className={classes.icon}
      data-testid={selected ? 'selected' : 'unselected'}
    />
  );
}

export default Radio;
